import { render, staticRenderFns } from "./AttachmentImageResolver.vue?vue&type=template&id=c751f2aa&scoped=true&"
import script from "./AttachmentImageResolver.vue?vue&type=script&lang=js&"
export * from "./AttachmentImageResolver.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentImageResolver.vue?vue&type=style&index=0&id=c751f2aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c751f2aa",
  null
  
)

export default component.exports